module.exports = __webpack_public_path__ + "media/images/redesign-images/about-us/group-ordering-02-9a5fbe205efd7d21afab71f1b1fcdda4.jpg";